import { useMutation, useQueryClient } from "@tanstack/react-query"
import { isAxiosError } from "axios"

import { startTasksFn } from "@/api/tasksApi"
import { showToast } from "@/shared/utils"

export const useStartTask = () => {
  const queryClient = useQueryClient()

  return useMutation(() => startTasksFn(), {
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ["checkTask"],
      }),
    onError: (error) => {
      if (isAxiosError(error)) {
        showToast({
          type: "error",
          text: error.response?.data.errorMessage || error.message,
          autoClose: false,
        })
      }
    },
  })
}
